<template lang="pug">
    .z-deal-status-changer(v-if="$props.dealId" v-loader-overlay="progressForm" v-on:click="preventClick")
        z-select(
            class="status-id" name="status_id" id="status_id" 
            v-bind:label="( $props.hideLabel ? '' : 'Статус заявки')" 
            v-model="form.status_id" 
            v-on:change="showChangeStatusDialog"
            v-bind:disabled="$props.disabled"
        )
            option(v-for="item in dealStatuses" v-bind:value="item.id" v-bind:style="'color:  ' + (item.color ? item.color : '#000') + '; font-weight: bold;'") {{item.name}}

        md-dialog(v-bind:md-active.sync="changeStatusDialog" md-theme="white")
            md-dialog-title Вы уверены в изменении статуса заявки?
            md-dialog-content
                z-select(
                    v-if="currentDealStatus && currentDealStatus.reasons && currentDealStatus.reasons.length"
                    class="status-reason" name="reason_id" id="reason_id" label="Признак отмены" v-model="form.reason_id"
                    v-validate="{required: true}" v-bind:error="errors.first('status.reason_id')"
                    data-vv-name="reason_id" v-bind:data-vv-as="' '" data-vv-scope="status"
                )
                    option(v-for="item in currentDealStatus.reasons" v-bind:value="item.id") {{item.name}}

                z-text-area(
                    v-if="currentDealStatusReason && parseInt(currentDealStatusReason.comment_require) === 1"
                    v-model="changeStatusMessage"
                    id="change_message" name="change_message" label="Комментарий" required
                    v-validate="{required: true}" v-bind:error="errors.first('status.change_message')"
                    data-vv-name="change_message" v-bind:data-vv-as="' '" data-vv-scope="status"
                )
            md-dialog-actions
                md-button.md-primary(@click="hideChangeStatusDialog") Отмена
                md-button.md-primary(@click="changeStatus(form.status_id, form.reason_id, changeStatusMessage)") Ок
</template>
<script>
    import ZSelect from '@/components/ZSelect';
    import ZInput  from '@/components/ZInput';
    import ZTextArea  from '@/components/ZTextArea';
    export default {
        name: 'z-deal-status-changer',
        components: {ZSelect, ZInput, ZTextArea},
        props: {
            dealId: {
                type: Number,
                default: null
            },
            value: {
                type: [Number, String],
                default: () => null
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            statusRequest: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loadKey: 'load-deal-status',
                changeStatusDialog: false,
                changeStatusMessage: null,
                form: {
                    status_id: null,
                    prev_status_id: null,
                    reason_id: null,
                    comment:   null
                }
            }
        },
        created() {
            this.$nextTick(() => {
                if (this.$props.value) this.form.status_id = this.$props.value;
                if (this.$props.statusRequest && (!this.dealStatuses || !this.dealStatuses.length)) this.getDealStatuses();
            });
        },
        watch: {
            '$props.value'(value) {
                if (value != this.form.status_id) this.form.status_id = value;
            },
            'form.status_id'(n, o) {
                this.form.prev_status_id = o
            }
        },
        computed: {
            progressForm() {
                return this.progressObj[this.loadKey];
            },
            progressObj() {
                return this.$store.state.progressObj;
            },
            dealStatuses() {
                return (this.$store.state.deals && this.$store.state.deals.statusesall) ? this.$store.state.deals.statusesall : [];
            },
            currentDealStatus() {
                return this.dealStatuses.find(item => parseInt(item.id) === parseInt(this.form.status_id));
            },
            currentDealStatusReason() {
                if (!this.currentDealStatus || !this.currentDealStatus.reasons || !this.currentDealStatus.reasons.length) return;
                return this.currentDealStatus.reasons.find(item => parseInt(item.id) === parseInt(this.form.reason_id));
            },
        },
        methods: {
            preventClick(e) {
                if (e) e.preventDefault();
            },
            getDealStatuses() {
                return this.$store.dispatch('deals/getAllStatuses');
            },
            showChangeStatusDialog() {
                this.$nextTick(() => {
                    this.changeStatusDialog = true;
                });
            },
            hideChangeStatusDialog() {
                this.form.status_id = this.form.prev_status_id
                this.changeStatusDialog = false;
            },
            changeStatus(statusId, reasonId, comment) {
                this.$validator.validateAll('status').then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', this.loadKey);
                    return this.$store.dispatch('deals/setDealStatus', {
                        id: this.$props.dealId, status_id: statusId, reason_id: reasonId, comment: comment
                    }).then(r => {
                        this.$emit('change', statusId);
                        this.$emit('input', statusId);
                        this.$emit('update', this.currentDealStatus)

                        this.$store.commit('showSnackbar', ['Статус обновлён, обновление формы...', 6000, 'success']);
                    }).finally(() => {
                        this.changeStatusMessage = false;
                        this.changeStatusDialog  = false;
                        this.$store.commit('hideProgressBar', this.loadKey);
                    });
                });
            },
        }
    }
</script>
<style scoped lang="sass">
    .z-deal-status-changer
        width: 100%
        margin: 0 10px 0 0
</style>



// WEBPACK FOOTER //
// ZDealStatusChanger.vue?440f714c